export const Radio = {
  parts: ['container', 'control', 'label'],
  defaultProps: {
    colorScheme: 'green',
  },
  baseStyle: {
    control: {
      bg: 'brand.white',
      fontWeight: 300,
      color: 'brand.white',
      border: '1px solid',
      borderColor: 'brand.midgrey',
    },
    label: {
      fontSize: '10px',
      marginRight: '16px',
      fontWeight: 400,
    },
  },
  sizes: {
    lg: {
      label: {
        fontSize: '16px',
      },
      control: {
        width: '32px',
        height: '32px',
      },
    },
  },
};
